var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row map-list-item route",attrs:{"title":this.entryData.nimi},on:{"click":_vm.itemClicked}},[_c('div',{staticClass:"col-1 id"},[_vm._v(_vm._s(this.entryData.linja))]),_c('div',{staticClass:"col name"},[_vm._v(_vm._s(this.nimi))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }